import { Box } from '@mui/material'
import React from 'react'
import Nav from './Nav'
import Footer from './Footer'
import { Upgrade } from './UserComponent/Profile/Upgrade'

export const Upgrades = () => {
    return (
        <Box >
            <Nav />
            <Box mt={12} mb={5}>
                <section className="mt-5 ">
                    <div className="container">
                        <Upgrade />
                    </div>
                </section>
            </Box>
            <Footer />
        </Box>
    )
}
